/* import { nullSafeIsEquivalent } from '@angular/compiler/src/output/output_ast'; */
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, FormControl, Validators, UntypedFormBuilder, UntypedFormArray, Form, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { textChangeRangeIsUnchanged } from 'typescript';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { PlayerContactModel } from '../../../shared/models/player.model';
import { ResponseModel } from '../../../shared/models/ResponseModel';
import { ScoutingPlayerService } from '../../../shared/services/scouting-player.service';
import { TranslatePipe } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';

@Component({
    selector: 'app-add-player-contact-dialog',
    imports: [ReactiveFormsModule, MatLabel, MatFormFieldModule, MatIconModule, MatButtonModule, MatInputModule, MatDialogModule, TranslatePipe, UpperCasePipe],
    templateUrl: './add-player-contact-dialog.component.html',
    styleUrls: ['./add-player-contact-dialog.component.css']
})
export class AddPlayerContactDialogComponent implements OnInit {

  form: UntypedFormGroup;
  isUpdate: boolean;

  constructor(     
    public _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AddPlayerContactDialogComponent>,
    public fb: UntypedFormBuilder,
    private scoutingService: ScoutingPlayerService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.isUpdate= this.data.Contact != null;

    if(this.isUpdate){
      //update
      var contact = this.data.Contact as PlayerContactModel;
      this.form = this.fb.group({
        PlayerId: contact.PlayerId,
        ContactId: contact.ContactId,
        FirstName: [contact.FirstName,[Validators.required, Validators.maxLength(50)]],
        LastName: [contact.LastName,[Validators.required, Validators.maxLength(50)]],
        Relation: [contact.Relation,[Validators.maxLength(50)]],
        CompanyName: [contact.CompanyName,[Validators.maxLength(150)]],
        Email: [contact.Email,[Validators.maxLength(150)]],
        HomePhone: [contact.HomePhone,[Validators.maxLength(50)]],
        WorkPhone:[contact.WorkPhone,[Validators.maxLength(50)]],
        MobilePhone: [contact.MobilePhone,[Validators.maxLength(50)]],
        Addresses: this.fb.array([])
                  

      });   
      var addresses = this.form.get('Addresses') as UntypedFormArray;
      contact.Addresses.forEach(address=>{
        addresses.push(
          this.fb.group({            
            AddressId: address.AddressId,
            AddressType: address.AddressType,
            Address1: address.Address1,
            Address2: address.Address2,
            Address3: address.Address3,
            PostCode: address.PostCode,
            City: address.City,
            Country: address.Country
          })
        );
      });



    }else{
      //New
      this.form = this.fb.group({
        PlayerId: this.data.PlayerId,
        FirstName: ['',[Validators.required, Validators.maxLength(50)]],
        LastName: ['',[Validators.required, Validators.maxLength(50)]],
        Relation: ['',[Validators.maxLength(50)]],
        CompanyName: ['',[Validators.maxLength(150)]],
        Email: ['',[Validators.maxLength(150)]],
        HomePhone: ['',[Validators.maxLength(50)]],
        WorkPhone:['',[Validators.maxLength(50)]],
        MobilePhone: ['',[Validators.maxLength(50)]],
        Addresses: this.fb.array([this.fb.group({
          AddressId: '1',
          AddressType: '-',
          Address1: '',
          Address2: '',
          Address3: '',
          PostCode: '',
          City: '',
          Country: ''
        })
          
        ])
      });   

    }


  }

  get Addresses(): UntypedFormArray{
    //console.log(this.form.get('Addresses'));
    return this.form.get('Addresses') as UntypedFormArray;
  }

  save(){
    // console.log("save");console.log(this.form.value);
    if(this.isUpdate){
      //Update
      // console.log('Update');
      this.scoutingService.updatePlayerContact(this.form.value).subscribe(response =>{
        // console.log(response);
        var resp = response as ResponseModel;
  
        if(resp.Success){
          this.dialogRef.close(true);
        }else{
          this.openSnackBar("Update contact failed:"  + resp.Message, 'OK');
        }
      });
    }else{
      //New
      this.scoutingService.addPlayerContact(this.form.value).subscribe(response =>{
        var resp = response as ResponseModel;
  
        if(resp.Success){
          this.dialogRef.close(true);
        }else{
          this.openSnackBar("Create contact failed:"  + resp.Message, 'OK');
        }
      });
    }
    

    

  }

  onCancel(){
    this.dialogRef.close();
    
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }


}
